export var ANALYTICS_HOVER_DELAY = 1000;
//# sourceMappingURL=constants.js.map